<input type="file" #file (change)="onFilesAdded()" />
<div class='button' (click)='addFiles()' 
     [class.selected]='selectedInternal'
     [class.active]='activeInternal'
     [class.success]='successInternal'
     >
    <div *ngIf='!activeInternal && !selectedInternal' class='message'>{{ content.uploadFileText }}</div>
    <div *ngIf='activeInternal' class='message'>{{ selectedFile.name }}</div>
    <div *ngIf='!activeInternal && selectedInternal && successInternal' class='message'>{{ content.uploadedFileText }}</div>
    <div *ngIf='!activeInternal && selectedInternal && !successInternal' class='message'>{{ content.notUploadedFileText }}</div>
    <div *ngIf='activeInternal' class='progress'>
        <div class='bar' [style.left]='(progressInternal-100) + "%"'>
        </div>
    </div>
</div>
